<template>
  <div class="forgot-password-container">
    <form @submit.prevent="handleForgotPassword">
      <span class="full-width d-inline-block text-center"
        style="font-size: 20px; font-weight: 600; margin-bottom: 20px">
        Forgot your password?
      </span>
      <p class="text-center text-muted" style="margin-bottom: 30px;">
        Enter your registered email address. We'll send you a link to reset your password.
      </p>

      <div class="form-group margin-base-y" style="position: relative;">
        <label for="forgot-email" class="control-label">Email address:</label>
        <div class="input-container">
          <input type="email" id="forgot-email" class="form-control input-field"
            placeholder="Enter your email"
            v-model="email"
            @input="handleEmailChange">
          <div class="input-icon" v-if="emailValidating && email.length > 0">
            <div class="spinner-border spinner-border-sm text-primary" role="status">
              <span class="sr-only">Loading...</span>
            </div>
          </div>
          <div class="input-icon" v-else-if="emailValidated">
            <i class="fa fa-check-circle mail-checked"></i>
          </div>
        </div>
        <div class="text-danger" v-if="emailError" style="position: absolute;">{{ emailError }}</div>
      </div>

      <div class="form-group" style="margin-top: 30px;">
        <button type="submit" class="login-button" :disabled="!emailValidated || isLoading">
          <img src="static/img/loader.gif" v-if="isLoading" class="next-arrow">
          <span v-else>
            Send Reset Link
          </span>
        </button>
      </div>

      <div class="text-success text-center" v-if="successMessage">{{ successMessage }}</div>

      <div class="text-center back-login">
        <span @click="$emit('back-to-login')" class="text-link">
          Back to Login
        </span>
      </div>
    </form>
  </div>
</template>

<script>
import firebase from "../../assets/config/firebase";
import helpers from "../../../src/assets/config/helpers";
import swal from "sweetalert";

export default {
  name: "ForgotPassword",
  data() {
    return {
      email: '',
      emailError: '',
      emailValidated: false,
      emailValidating: false,
      isLoading: false,
      successMessage: '',
      companies: [],
      selectedCompany: null,
      selectedCompanyId: null,
      emailCheckTimeout: null
    };
  },
  methods: {
    handleEmailChange() {
      if (this.emailCheckTimeout) {
        clearTimeout(this.emailCheckTimeout);
      }
      this.emailError = "";
      this.emailValidated = false;
      this.successMessage = "";
      this.selectedCompany = null;
      this.companies = [];

      if (!this.email) {
        this.emailValidating = false;
        return;
      }

      // Check if there is at least one '.' after '@'
      const atIndex = this.email.indexOf('@');
      if (atIndex === -1) {
        this.emailValidating = false;
        return;
      }
      const domainPart = this.email.slice(atIndex + 1);
      if (!domainPart.includes('.')) {
        this.emailValidating = false;
        return;
      }

      this.emailCheckTimeout = setTimeout(async () => {
        const { emailRegex } = helpers;

        if (!emailRegex.test(this.email)) {
          this.emailError = "Please enter a valid email address";
          this.emailValidating = false;
          return;
        }

        this.emailValidating = true;
        try {
          const response = await this.findCompany();
          if (!this.email) {
            this.emailValidating = false;
            return;
          }

          if (response && response.length > 0) {
            this.companies = response;
            this.selectCompany(response[0]);
            this.emailValidated = true;

            if (response.length > 1) {
              this.selectedCompanyId = response[0].id || response[0].companyName;
              this.openCompanyModal();
            }
          } else {
            this.emailError = "No account found with this email";
          }
        } catch (e) {
          if (e.message === "you are not added by any company") {
            this.emailError = "You have not been added to any company yet";
          } else {
            this.emailError = e.message;
          }
        } finally {
          this.emailValidating = false;
        }
      }, 1000);
    },

    async handleForgotPassword() {
      if (!this.emailValidated || !this.selectedCompany) {
        this.emailError = "Please enter a valid email associated with a company";
        return;
      }
      this.isLoading = true;
      this.emailError = '';
      this.successMessage = '';

      try {
        if (firebase.checkAlreadyConfiguredApp()) {
          await firebase.unconfigureFirebase();
        }
        await firebase.configureFirebase(this.selectedCompany.firebase);

        const resetUrl = `${window.location.origin}/#/resetPassword?email=${this.email.toLowerCase()}`;
        await firebase.sendPasswordResetEmail(this.email.toLowerCase(), resetUrl);

        this.successMessage = `Password reset instructions have been sent to this email, ${this.email.toLowerCase()}`;
        swal("Success", this.successMessage, "success");
      } catch (error) {
        this.emailError = error.message || "Failed to send reset instructions. Please try again.";
        swal("Error", this.emailError, "error");
      } finally {
        this.isLoading = false;
      }
    },

    async findCompany() {
      return await this.$parent.findCompany(this.email.toLowerCase());
    },

    selectCompany(company) {
      this.selectedCompany = company;
    },

    openCompanyModal() {
      // Implement if needed for multiple companies
    }
  }
};
</script>

<style scoped>
/* Add your custom styles if needed */
</style>


// WEBPACK FOOTER //
// src/components/Login/ForgotPassword.vue